"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("settings-content-modals/data/Owners/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-content-modals/data/RequestStatuses/reducer"));

var _reactRouterRedux = require("react-router-redux");

var _default = (0, _redux.combineReducers)({
  owners: _reducer.default,
  requests: _reducer2.default,
  routing: _reactRouterRedux.routerReducer
});

exports.default = _default;
module.exports = exports.default;